import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

export default function QuickLinks() {
  const { t } = useTranslation();

  const LINKS = [
    { icon: '✍️', label: t('quick_join'),     href: '/join',      accent: '#10b981' },
    { icon: '📄', label: t('quick_docs'),     href: '/documents', accent: '#0891b2' },
    { icon: '📰', label: t('nav_news'),       href: '/news',      accent: '#1e40af' },
    { icon: '📞', label: t('quick_contacts'), href: '/contacts',  accent: '#7c3aed' },
  ];

  return (
    <section style={{ background: 'var(--secondary)', padding: 'clamp(32px, 5vw, 64px) clamp(16px, 4vw, 32px)' }}>
      <div style={{ maxWidth: 1280, margin: '0 auto' }}>
        <div style={{ textAlign: 'center', marginBottom: 40 }}>
          <h2 style={{ fontFamily: 'Montserrat, sans-serif', fontSize: '1.8rem', fontWeight: 700, color: '#fff', marginBottom: 8 }}>
            {t('footer_quick_links')}
          </h2>
          <p style={{ color: 'rgba(255,255,255,0.7)', fontSize: '0.95rem' }}>
            {t('footer_all_in_one')}
          </p>
        </div>
        <div className="quick-links" style={{ justifyContent: 'center' }}>
          {LINKS.map(link => (
            <Link key={link.href} to={link.href} style={{ flex: '1 1 180px', maxWidth: 240, background: 'rgba(255,255,255,0.08)', backdropFilter: 'blur(8px)', color: '#fff', textDecoration: 'none', padding: '32px 24px', borderRadius: 16, textAlign: 'center', fontWeight: 600, fontSize: '0.95rem', border: '1px solid rgba(255,255,255,0.15)', transition: 'all 0.25s', display: 'block' }}
              onMouseEnter={e => { const el = e.currentTarget as HTMLElement; el.style.background = link.accent; el.style.borderColor = link.accent; el.style.transform = 'translateY(-6px)'; el.style.boxShadow = '0 12px 32px rgba(0,0,0,0.2)'; }}
              onMouseLeave={e => { const el = e.currentTarget as HTMLElement; el.style.background = 'rgba(255,255,255,0.08)'; el.style.borderColor = 'rgba(255,255,255,0.15)'; el.style.transform = 'translateY(0)'; el.style.boxShadow = 'none'; }}>
              <span style={{ fontSize: '2.4rem', display: 'block', marginBottom: 12 }}>{link.icon}</span>
              {link.label}
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}
